import {
  type HubStorageCapacity,
  HubStorageCapacityServiceId,
} from '@robovision/hub'
import { addOrReplaceByKey } from '@robovision/rvai-utils'
import { defineStore } from 'pinia'
import {
  reactive,
  readonly,
  toRefs,
} from 'vue'
import { StorageCapacity } from '~domain/storage/StorageCapacity'
import { hubApi } from '~services/api'


interface StoragesState {
  storages: StorageCapacity[],
}

export const useStoragesStore = defineStore('storage', () => {
  const state = reactive<StoragesState>({
    storages: [],
  }) as StoragesState

  const getters = {
    getStorage (id: HubStorageCapacityServiceId): StorageCapacity | undefined {
      return state.storages.find(s => s.serviceId === id)
    },
  }

  const actions = {
    handleStorageCapacityMessage (data: HubStorageCapacity): void {
      const storage = StorageCapacity.fromResponse(data)

      state.storages = addOrReplaceByKey(state.storages, storage, 'serviceId')
    },

    async loadStoragesCapacity (): Promise<void> {
      const { data } = await hubApi.storageCapacity.getStorageCapacities()
      state.storages = data.items.map(StorageCapacity.fromResponse)
    },

    setState (params: Partial<typeof state>): void {
      Object.assign(state, params)
    },
  }

  return {
    ...toRefs(readonly(state)),
    ...getters,
    ...actions,
  }
})
